import {
	FieldTeamDetail,
	FieldTeamDetailGeneralInformation,
} from './field-team-detail.models';
import { FieldTeam } from 'src/shared/api';

export function fieldTeamFormToFieldTeam(
	formValue: FieldTeamDetail
): FieldTeam {
	let team: FieldTeam;
	if (formValue) {
		const { members, ...details } = formValue;

		team = {
			members,
			...details.generalInfo,
		};
	}
	return team;
}

export function fieldTeamToFieldTeamForm(
	team: FieldTeam
): FieldTeamDetail | null {
	if (team) {
		return {
			generalInfo: fieldTeamToGeneralInfo(team),
			members: team.members,
		};
	} else {
		return {
			generalInfo: null,
			members: [],
		};
	}
}

function fieldTeamToGeneralInfo(
	team: FieldTeam
): FieldTeamDetailGeneralInformation {
	return {
		id: team.id,
		fieldManager: team.fieldManager,
		emailAddress: team.emailAddress,
		name: team.name,
	};
}
